import { Grid } from '@mui/material';

import { useAlertsForm } from './hook';
import { AlertProcess } from './process';
import { AlertExecution } from './execution';

import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    ALERTS,
    ALERTS_EDIT,
    ALERTS_DETAIL,
} from '../../../../../routes/paths';

export const AlertsForm = () => {
    const {
        alert,
        loading,
        setFormikProcess,
        setFormikAlertSection,
        handleSubmit,
        handleClean,
        formikProcess,
    } = useAlertsForm();

    return (
        <>
            <FormView
                title={
                    alert && alert.id
                        ? 'Editar regla alertas'
                        : 'Crear regla alertas'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={alert?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: ALERTS,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: ALERTS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: ALERTS_DETAIL,
                        }}
                    />
                }
            />
            <AlertProcess
                data={alert}
                onChangeFormik={(formik) => setFormikProcess(formik)}
            />
            <AlertExecution
                data={alert?.alertSection}
                receivedThrough={formikProcess?.values.receivedThrough}
                onChangeFormik={(formik) => setFormikAlertSection(formik)}
                canSendEmail={formikProcess?.values?.canSendEmail || false}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!alert || !alert.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
